var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83398 4.16602H7.9934V10.4559C7.9934 11.3537 8.14799 12.0197 8.45717 12.4538C8.76635 12.8879 9.28326 13.105 10.0079 13.105C10.7325 13.105 11.2446 12.8879 11.5441 12.4538C11.8533 12.0197 12.0079 11.3537 12.0079 10.4559V4.16602H14.1673V10.4559C14.1673 11.255 14.0707 11.9408 13.8775 12.513C13.6842 13.0853 13.4089 13.5589 13.0514 13.9338C12.6939 14.2988 12.2543 14.5652 11.7325 14.733C11.2205 14.9106 10.6407 14.9993 9.99341 14.9993C9.3364 14.9993 8.74703 14.9106 8.22529 14.733C7.71321 14.5554 7.27843 14.284 6.92094 13.919C6.56345 13.5441 6.29292 13.0655 6.10935 12.4834C5.92577 11.9013 5.83398 11.2106 5.83398 10.4115V4.16602Z",
    fill: "#7A7A7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 16.2507C5 16.0205 5.18655 15.834 5.41667 15.834H14.5833C14.8135 15.834 15 16.0205 15 16.2507C15 16.4808 14.8135 16.6673 14.5833 16.6673H5.41667C5.18655 16.6673 5 16.4808 5 16.2507Z",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderlineIcon);
export default __webpack_public_path__ + "static/media/underline_icon.56ba046d0670544664cc1e3b4965e699.svg";
export { ForwardRef as ReactComponent };